import { BasicStats, CallStats, getPrintIndentation, StatsCommon } from '#common/stats';
import { PATH_SEPARATOR, ROOT_PATH } from './constants';
export class PathStats extends CallStats {
    pathLen = new BasicStats();
    toString() {
        return (super.toString() + ` avgPathLen=${this.pathLen.avg().toFixed(1)} maxPathLen=${this.pathLen.max().toFixed()}`);
    }
    updatePathLen(path) {
        this.pathLen.update(PathStats.getPathLen(path));
    }
    /*
    example paths and their lengths:
    "/", "" -> len=0
    "/path", "path", "path/" -> len=1
    "/path1/path2", "path1/path2", "/path1/path2/", "path1/path2/" -> len=2
    */
    static getPathLen(path) {
        if (path == ROOT_PATH || path == PATH_SEPARATOR) {
            return 0;
        }
        return path.split(PATH_SEPARATOR).filter((s) => s.length > 0).length;
    }
}
export class FileSystemStats extends StatsCommon {
    // totals
    totalBytesRead = 0;
    totalBytesWritten = 0;
    // public API
    getEntryKey;
    readFile;
    writeFile;
    getPath;
    getPathsByIdsBulk;
    getMetadata;
    readDir;
    readDirPaginated;
    readDirIterator;
    fileExists;
    dirExists;
    createLink;
    createHardLink;
    readLink;
    deleteLink;
    createDir;
    createDirById;
    deleteDir;
    deleteDirById;
    resolve;
    createFile;
    deleteFile;
    move;
    // internals
    getEntryInfoById;
    fileStore;
    constructor(log) {
        super();
        this.getEntryKey = new PathStats('getEntryKey', log);
        this.readFile = new CallStats('readFile', log);
        this.writeFile = new CallStats('writeFile', log);
        this.getPath = new PathStats('getPath', log);
        this.getPathsByIdsBulk = new CallStats('getPathsByIdsBulk', log);
        this.getMetadata = new CallStats('getMetadata', log);
        this.readDir = new CallStats('readDir', log);
        this.readDirPaginated = new CallStats('readDirPaginated', log);
        this.readDirIterator = new CallStats('readDirIterator', log);
        this.fileExists = new CallStats('fileExists', log);
        this.dirExists = new CallStats('dirExists', log);
        this.createLink = new CallStats('createLink', log);
        this.createHardLink = new CallStats('createHardLink', log);
        this.readLink = new CallStats('readLink', log);
        this.deleteLink = new CallStats('deleteLink', log);
        this.createDir = new CallStats('createDir', log);
        this.createDirById = new CallStats('createDirById', log);
        this.deleteDir = new CallStats('deleteDir', log);
        this.deleteDirById = new CallStats('deleteDirById', log);
        this.resolve = new CallStats('resolve', log);
        this.createFile = new CallStats('createFile', log);
        this.deleteFile = new CallStats('deleteFile', log);
        this.move = new CallStats('move', log);
        this.getEntryInfoById = new CallStats('getEntryInfoById', log);
    }
    toString(indentLevel) {
        let result = super.toString(indentLevel);
        this.addIndentation(result, indentLevel);
        result += `totalBytesRead=${this.totalBytesRead.toFixed()}`;
        this.addIndentation(result, indentLevel);
        result += `totalBytesWritten=${this.totalBytesWritten.toFixed()}`;
        return result;
    }
    addIndentation(result, indentLevel) {
        // eslint-disable-next-line no-useless-assignment -- v8 new core rule; leaving the explicit initializer for the team to assess
        result += '\n' + getPrintIndentation(indentLevel);
    }
}
